<template>
<div class="sezione"  style="padding:0 8px;" v-if="ready">


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 36px;">
         <el-breadcrumb-item><span class="yo-text-bold yo-text-m">Mortalità alla dimissione per centro</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class=" yo-text-m">EG {{gaweakDown}}-{{gaweakUp}} sett.</span></el-breadcrumb-item>
         <!-- <el-breadcrumb-item><span class="yo-text-m">Anno {{anno}}}</span></el-breadcrumb-item> -->
         <el-breadcrumb-item>
            <el-select v-model="anno" placeholder="Select"  v-on:change="makeanalisi" size="small" style="width:150px;">
               <el-option label="Anno 2020" :value="2020"></el-option>
               <el-option label="Anno 2019" :value="2019"></el-option>
            </el-select>
         </el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>

<div style="margin:22px 0 52px 0;">

<!--
   <div class="yo-text-xl  yo-color-primary yo-align-center" style="margin-bottom:12px;">Mortalità alla dimissione per centro (esclusi neonati con malformazioni letali).<br />EG {{gaweakDown}}-{{gaweakUp}} sett. - INNSIN 2019</div>
-->

   <div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:#ddd;width:100%;position: relative;" >

      <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(100))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(95)>0 && ordinata(95)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(95))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(90))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(85)>0 && ordinata(85)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(85))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(80))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(75)>0 && ordinata(75)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(75))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(70))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(65)>0 && ordinata(65)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(65))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(60))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(55)>0 && ordinata(55)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(55))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(50))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(45)>0 && ordinata(45)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(45))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(40))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(35)>0 && ordinata(35)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(35))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(30))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(25)>0 && ordinata(25)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(25))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(20))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(15)>0 && ordinata(15)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(15))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(10))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />
      <div v-if="(ordinata(5)>0 && ordinata(5)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(5))+'px'" style="border-bottom:1px solid white;position:absolute;width:10px;left:30px;" />
      <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(0))+'px'" style="border-bottom:1px solid white;position:absolute;width:18px;left:22px;" />

<div  :style="'bottom:40%'" style="position:absolute;width:22px;left:0;" class="yo-rotate white ">Percentuale</div>



      <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(100)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">100</div>
      <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(90)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">90</div>
      <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(80)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">80</div>
      <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(70)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">70</div>
      <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(60)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">60</div>
      <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(50)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">50</div>
      <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(40)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">40</div>
      <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(30)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">30</div>
      <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(20)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">20</div>
      <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(10)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">10</div>
      <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(0)+gHeightMore)+'px'" style="position:absolute;width:39px;" class=" white yo-align-right yo-text-n">0</div>



      <div :style="'top:'+(gHeight+gHeightMore-ordinata(q3))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />
      <div :style="'top:'+(gHeight+gHeightMore-ordinata(network.m))+'px'" style="border-bottom:1px dashed #1a476f;position:absolute;right:0;left:40px;" />
      <div :style="'top:'+(gHeight+gHeightMore-ordinata(q1))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />


      <div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:grey;float:left;width:40px;color:white;text-align:center;" />


      <div  style="float:left;width:calc(100% - 40px);padding:40px 0 40px 0;"  >
         <div v-for="(itm, index) in items" :key="'_'+itm.centro" v-on:click="centroSel=itm.centro" :class="(itm.centro==centroSel?'selezionato':'')" class="g-confidenza yo-align-center" style="float:left;position:relative;" :style="'height:'+gHeight+'px;width: '+(100/items.length)+'%'" :id="'centro_'+index">
            <div class="g-confidenza-f2" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f2))+'px'"  />
            <div class="g-confidenza-m" :style="'top:'+(gHeight-ordinata(itm.m)-5)+'px'"  />
            <div class="g-confidenza-f1" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f1))+'px'" />
            <div class="g-confidenza-line" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f2))+'px;bottom:'+(ordinata(itm.f1))+'px;'" style="position:absolute;width:1px;left:50%;background:black;" />
         </div>
      </div>

   </div>


<div style="background:#ddd;">
   <div :style="'height:'+32+'px'" style="background:grey;color:white;margin-left:40px;" >
      <div v-for="(itm, index) in items" :key="'_'+itm.centro" class="col sm yo-valign-text-center yo-align-center yo-text-s" style="height:32px;float:left;" :style="'width: '+(100/items.length)+'%'" :id="'centro_'+index">
         {{index+1}}
      </div>
   </div>

   <div :style="'height:'+26+'px'" style="background:grey;margin-bottom:22px;color:white;margin-left:40px;" class="yo-align-center">
      Posizione (rango) del centro
   </div>
</div>

<!--
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3m yo-text-bold yo-align-right">ASCISSE</div>
         <div class="col s8m">Posizione (rango) del centro</div>
   </div>
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3m yo-text-bold yo-align-right">ORDINATE</div>
         <div class="col s8m">Tasso di mortalità (%)</div>
   </div>

   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">LINEE TRATTEGGIATE</div>
         <div class="col s9">La linea centrale indica il valore mediano (50°percentile) del tasso di mortalità intraospedaliero (escluse malformazioni letali) dell'intero Network mentre quella superiore ed inferiore rappresentano rispettivamente il 25° percentile ed il 75°percentile della distribuzione dell’indicatore nell'intero Network.</div>
   </div>
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">NOTE</div>
         <div class="col s9">
         Per ogni centro è presentata la stima puntuale dell’indicatore (cerchio pieno) con il relativo Intervallo di Confidenza al 95% (IC95%) (linea verticale). Nei centri con un numero di neonati pari o inferiore a 15 viene presentata solo la stima puntuale dell’indicatore.
         <br />
         In colore rosso è evidenziato il vostro centro. 
         <br />
         Se il limite inferiore dell’intervallo di confidenza di un centro è maggiore del 75° percentile della distribuzione delle percentuali di mortalità dell’intero network, significa che il centro si colloca nel gruppo del 25% dei centri con la più elevata percentuale di mortalità.
         <br />
         Se il limite superiore dell’intervallo di confidenza di un centro è minore del 25° percentile della distribuzione delle percentuali di mortalità dell’intero network, significa che il centro si colloca nel gruppo del 25% dei centri con la più bassa percentuale di mortalità.
         </div> 
   </div>
-->
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s12 yo-text-bold ">GUIDA ALLA LETTURA DEL GRAFICO</div>
         <div class="col s12">
         La linea orizzontale centrale indica il valore mediano (50°percentile) delll'indicatore dell'intero Network mentre quella orizzontale superiore ed inferiore rappresentano rispettivamente il 25° percentile ed il 75°percentile della distribuzione dell’indicatore nell'intero Network.
         <br />
         Per ogni centro è presentata la stima puntuale dell’indicatore (cerchio pieno) con il relativo Intervallo di Confidenza al 95% (IC95%) (linea verticale). Nei centri con un numero di neonati pari o inferiore a 15 viene presentata solo la stima puntuale dell’indicatore.
         <br />
         In colore rosso è evidenziato il vostro centro.
         <br />
         Se il limite inferiore dell’intervallo di confidenza di un centro è al di sopra del 75° percentile dell’indicatore dell’intero network (linea orizzontale superiore), significa che il centro si colloca nell’ultimo 25% della distribuzione dell’indicatore ordinato in modo crescente, in altri termini si colloca nel 25% dei centri con i valori più alti dell’indicatore.
         <br />
         Se il limite superiore dell’intervallo di confidenza di un centro è al di sotto del 25° percentile dell’indicatore dell’intero network (linea orizzontale inferiore), significa che il centro si colloca nel primo 25% della distribuzione dell’indicatore ordinato in modo crescente, in altri termini si colloca nel 25% dei centri con i valori più bassi dell’indicatore.
         <br />
         Si fa presente che il ranking mostrato nel grafico si basa sul calcolo del solo indicatore (dati “grezzi”), non tiene conto quindi di potenziali fattori di confondimento che potrebbero modificare la graduatoria dei centri.
         </div> 
   </div>

   <div v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'">
      <div class="row " style="clear:both;background:grey;color:white" >
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:40px;">MIN</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:40px;">MAX</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q1</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q3</div>
      </div>



      <div class="row " style="border-bottom:1px solid lightgrey;"  >
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:24px;">{{network.valore}}</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:24px;" >{{network.totale}}</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:24px;">{{minimo}}</div>
         <div class="col s1m yo-valign-text-center yo-align-center" style="height:24px;">{{massimo}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q1}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{network.m}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q3}}</div>
      </div>
   </div>






   <div v-if="false" class="row pad" style="clear:both;margin-bottom:12px;" ><div class="col s9 offset-s3">


      <div class="row " style="clear:both;background:grey;color:white" >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">NUM</div>
         <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">CENTRO</div> 
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% inf</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% sup.</div>
      </div>


      <div class="row " style="border-bottom:1px solid lightgrey;" v-for="(itm, index) in items" :key="itm.centro" v-on:click="centroSel=itm.centro" >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;">{{index+1}}</div>
         <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.centro}}</div> 
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;">{{itm.valore}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.totale}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f1}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.m}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f2}}</div>
      </div>

   </div></div>

</div>

</div>
</template>

<script>
import { quantileSeq,std,mean } from 'mathjs'
export default {
components: {
   
},
data() {
   return {
      loading:{}
      ,ready: false
      ,needReload: false
      ,item:{}

      ,anno:2020
      ,gHeight:540
      ,gHeightMore:40
      ,items: []
      ,ordinataMin: 0
      ,ordinataMax: 100
      ,network: {}
      ,centroSel: this.$centro.referente.row.centro
      ,q1:0
      ,q3:0
      ,gaweakDown:22
      ,gaweakUp:31

      ,limitebasso:100
      ,limitealto:0

      ,minimo: 1000
      ,massimo: -10000
   }
},
created () {
   this.makeanalisi ()
},
methods: {
   async makeanalisi () {
      /*Fino al 10 ottobre 2021
      let whereValue = "fdisp=3"
      let whereNCNR = "fdisp>-1"
      */

      let whereValue = "(deldie=1 or fdisp=3 or f2disp=3 or f3disp=3)"
      let whereNCNR = "(deldie>-1 or fdisp>-1 or f2disp>-1 or f3disp>-1)"


      
      this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      let q = await this.$axios.query('fetchAll',`SELECT centro AS centro, SUM(IF(←whereValue,1,0)) AS valore, SUM(IF(←whereValue,0,1)) AS valore2, count(*) AS totale, ROUND(SUM(IF(←whereValue,1,0))/count(*)*100,2) AS m, 0 AS f1, 0 AS f2
      FROM sin_inn.paziente WHERE (centro!=1 AND centro!=101 AND  centro!=10001 AND centro!=10012) AND byear = ←anno 
      AND gaweeks>= ←gaweakDown AND gaweeks<= ←gaweakUp AND ←whereNCNR
      GROUP BY centro HAVING totale>0 ORDER BY m DESC,totale DESC, centro`,{whereValue:whereValue, whereNCNR:whereNCNR, gaweakDown:this.gaweakDown, gaweakUp:this.gaweakUp, anno: this.anno})

      /*
      ometto AND chiusoil>0  perchè Francesco dice di considerarli comunque chiuse
      */
      let esito = await this.$axios.post(this.$axios.apiUrl+'vue/confidenza',{items:q.result})
      this.items = esito.data.data.items
      this.itemsError = esito.data.data.itemsError
      console.log("TOTALI: "+this.items.length)

      this.ordinataMin = this.items[this.items.length-1].f1//(this.items[0].f1 - 10>0) ? this.items[0].f1 - 10 : 0
      this.ordinataMax = 120//parseFloat(this.items[this.items.length - 1].f2) //(parseFloat(this.items[this.items.length - 1].f2) + 10<100) ? parseFloat(this.items[this.items.length - 1].f2) + 10 : 100

      let ultimo = this.items[this.items.length - 1]
      console.log("MIN: "+this.ordinataMin+" - MAX: "+ this.ordinataMax)

      let allValues = []
      for (let itm of this.items){
         allValues.push(itm.m)
         if(this.ordinataMax<parseFloat(itm.f2))
            this.ordinataMax = parseFloat(itm.f2)
         this.limitebasso = (itm.f1<this.limitebasso) ? itm.f1 : this.limitebasso
         this.limitealto = (itm.f2>this.limitealto) ? itm.f2 : this.limitealto

         if(this.minimo > itm.m)
            this.minimo = itm.m
         if(this.massimo < itm.m)
            this.massimo = itm.m
      }      
      this.q1 = parseFloat(quantileSeq(allValues, 0.25)).toFixed(2)
      this.q3 = parseFloat(quantileSeq(allValues, 0.75)).toFixed(2)

      let qT = await this.$axios.query('fetchAll',`SELECT centro AS centro, SUM(IF(←whereValue,1,0)) AS valore, SUM(IF(←whereValue,0,1)) AS valore2, count(*) AS totale, ROUND(SUM(IF(←whereValue,1,0))/count(*)*100,2) AS m, 0 AS f1, 0 AS f2
      FROM sin_inn.paziente WHERE (centro!=1 AND centro!=101 AND  centro!=10001 AND centro!=10012) AND byear = ←anno 
      AND gaweeks>= ←gaweakDown AND gaweeks<= ←gaweakUp AND ←whereNCNR
      ORDER BY m DESC,totale DESC, centro`,{whereValue:whereValue, whereNCNR:whereNCNR, gaweakDown:this.gaweakDown, gaweakUp:this.gaweakUp, anno: this.anno})
      let esitoT = await this.$axios.post(this.$axios.apiUrl+'vue/confidenza',{items:qT.result})
      this.network = esitoT.data.data.items[0]

      //await this.$axios.query('fetchAll','SELECT * FROM ←rTable;',{rTable:this.rTable})
      this.loading.close()
      this.ready = true
   },

   ordinataP(val){
      let newval = val*this.gHeight/this.ordinataMax 
      console.log(newval*100/this.gHeight)
      return newval*100/this.gHeight
   },

   ordinata(val){
      let traslazione=(this.limitebasso)*this.gHeight/100;
      let top=(this.limitealto*this.gHeight/100)-140;
      console.log(val*this.gHeight/this.ordinataMax)
      return (val*(this.gHeight+traslazione+top)/this.ordinataMax)-traslazione
   }
}, 
computed:{
   rTable:function(){      
      return 'r' + this.$centro.referente.row.centro
   }
}
}
</script>


<style >
.report_basico .vRow{
    background: #BDD1E8;
    background: #fbeafa;
}
.report_basico .vRow:nth-child(odd) {
    color: grey;
    background: #d7e5f7;
}
</style>
